import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import dayjs from "@/plugins/dayjs";
import { dateFormat } from "@/components/filters/DateTime";

@Component
export class DateRangeFilterMixin extends Vue {
  date: string[] | null = null;
  dateModal: string[] | null = null;
  modal: boolean = false;
  rangeDate: string = "Этот месяц";
  rangeDateItems: string[] = [
    "Эта неделя",
    "Прошлая неделя",
    "Этот месяц",
    "Прошлый месяц",
    "Свой период",
  ];

  setDatePicker() {
    if (this.dateModal && this.dateModal.length === 2) {
      this.date = [...this.dateModal];
      this.modal = false;
      this.rangeDate = "Свой период";
    }
  }

  get computedDateFormatted() {
    return this.date?.map(e => dateFormat(e)).join(" ~ ");
  }

  @Watch("rangeDate", { immediate: true })
  private onRangeDateChange(val: string): void {
    switch (val) {
      case "Этот месяц":
        this.date = [
          dayjs().format("YYYY-MM-01"),
          dayjs().format("YYYY-MM-DD"),
        ];
        break;
      case "Эта неделя":
        this.date = [
          dayjs()
            .startOf("isoWeek")
            .format("YYYY-MM-DD"),
          dayjs().format("YYYY-MM-DD"),
        ];
        break;
      case "Прошлая неделя":
        this.date = [
          dayjs()
            .subtract(1, "weeks")
            .startOf("isoWeek")
            .format("YYYY-MM-DD"),
          dayjs()
            .subtract(1, "weeks")
            .endOf("isoWeek")
            .format("YYYY-MM-DD"),
        ];
        break;
      case "Прошлый месяц":
        this.date = [
          dayjs()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD"),
          dayjs()
            .subtract(1, "months")
            .endOf("month")
            .format("YYYY-MM-DD"),
        ];
        break;
    }
  }
}
